import enLang from './entries/en-US';
import deLang from './entries/de_DE';

export const AppLocale = {
  en: enLang,
  de: deLang,
};
